interface Filter {
  nameSearch?: string;
  portfolioReleaseId?: string;
  active?: boolean;
  activeCompany?: boolean;
  domain?: string;
  object?: string;
  solutionId?: boolean | number | null;
  statusCode?: {eq: number} | number;
  validatedObjectId?: number;
  prospectId?: number;
  ids?: string[];
}

export interface SortBy {
  key: string;
  order?: boolean | 'asc' | 'desc';
}

export interface Options {
  page?: number;
  itemsPerPage?: number;
  totalItems?: number;
  order?: string;
  sortBy?: SortBy[];
  groupBy?: string[];
  sortDesc?: string[];
  groupDesc?: boolean;
  multiSort?: boolean;
  mustSort?: boolean;
  filter?: Filter;
}

export interface SavedOptions {
  page: number;
  itemsPerPage: number;
  totalItems?: number;
  order?: string;
  sortBy?: SortBy[];
  groupBy?: string[];
  groupDesc?: boolean;
  sortDesc?: string[];
  multiSort?: boolean;
  mustSort?: boolean;
  filter?: Filter;
}

function setNewOptions(options: Options): SavedOptions {
  return {
    page: options.page ?? 1,
    itemsPerPage: options.itemsPerPage ?? 10,
    totalItems: options.totalItems ?? 0,
    order: options.order ?? '',
    sortBy: options.sortBy ?? [],
    groupBy: options.groupBy ?? [],
    sortDesc: options.sortDesc ?? [],
    groupDesc: options.groupDesc ?? false,
    multiSort: options.multiSort ?? false,
    mustSort: options.mustSort ?? false,
    filter: {
      active: options.filter?.active,
      nameSearch: options.filter?.nameSearch,
      activeCompany: options.filter?.activeCompany,
      domain: options.filter?.domain,
      object: options.filter?.object,
      solutionId: options.filter?.solutionId,
      statusCode: options.filter?.statusCode,
      validatedObjectId: options.filter?.validatedObjectId,
      prospectId: options.filter?.prospectId,
      portfolioReleaseId: options.filter?.portfolioReleaseId,
      ids: options.filter?.ids,
    },
  };
}

export {setNewOptions};
